import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/css/styles.css'
import './assets/css/colors.css'
import './index.css'; // Sprint 7/12: utilities + skip link + focus visible
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './i18n'; // ⭐ Importar configuración de i18n

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
<HelmetProvider>
  <BrowserRouter basename="/modulob">
    <div id="main-wrapper">
      <App />
    </div>
  </BrowserRouter>
</HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
